"use client";

import { useTranslations } from "next-intl";
import { css, cx } from "styled-system/css";
import { center, flex, stack } from "styled-system/patterns";

import { DefaultError, HandleSuspenseQuery } from "@/components/handle-query";
import { MediaQuery } from "@/components/media-query";

import { AnnouncementsContent } from "./announcements-content";
import { AnnouncementsLoading } from "./components/announcements-loading";
import { CategorySelect } from "./components/category-select";
import { CategorySidebar } from "./components/category-sidebar";
import { useCategory } from "./use-category";

export default function AnnouncementsPage() {
  const t = useTranslations("announcements");

  const { category } = useCategory();

  return (
    <div
      className={stack({
        gap: "0",
        p: { base: "16", desktop: "24" },
        pb: "64",
        flex: "1",
        maxW: "[1200px]",
        mx: "auto",
        w: "full",
      })}
    >
      <h1
        className={css({
          textStyle: "heading.xs",
          color: "text.primary",
          mb: { base: "16", desktop: "24" },
        })}
      >
        {t("title")}
      </h1>

      <div
        className={flex({
          gap: { base: "0", desktop: "32" },
          align: "flex-start",
          flexDirection: { base: "column", desktop: "row" },
        })}
      >
        {/* Desktop category sidebar */}
        <MediaQuery display="above" breakpoint="desktop">
          {(className) => (
            <div className={cx(css({ flexShrink: 0, w: "[235px]" }), className)}>
              <CategorySidebar selectedCategory={category} />
            </div>
          )}
        </MediaQuery>

        {/* Mobile category select dropdown */}
        <MediaQuery display="below" breakpoint="desktop">
          {(className) => (
            <div className={cx(css({ w: "full", mb: "16" }), className)}>
              <CategorySelect selectedCategory={category} />
            </div>
          )}
        </MediaQuery>

        <HandleSuspenseQuery
          loading={<AnnouncementsLoading />}
          error={(fallbackProps) => (
            <div className={center({ w: "full", px: "32" })}>
              <DefaultError {...fallbackProps} />
            </div>
          )}
        >
          <AnnouncementsContent category={category} />
        </HandleSuspenseQuery>
      </div>
    </div>
  );
}
